module.exports = "https://tutorchat.chegg.com/static/media/ic-trash.077d5e0b.svg";